import { gql } from "@apollo/client";

export const ENSURE_QR_TOKEN_MUTATION = gql`
  mutation EnsureQrToken($resourceType: QrResourceType!, $resourceId: ID!) {
    ensureQrToken(resourceType: $resourceType, resourceId: $resourceId) {
      token
      url
      resourceType
      resourceId
      displayName
      secondaryLabel
    }
  }
`;

export const REGENERATE_QR_TOKEN_MUTATION = gql`
  mutation RegenerateQrToken($resourceType: QrResourceType!, $resourceId: ID!) {
    regenerateQrToken(resourceType: $resourceType, resourceId: $resourceId) {
      token
      url
      resourceType
      resourceId
      displayName
      secondaryLabel
    }
  }
`;

export const ENSURE_QR_TOKENS_BULK_MUTATION = gql`
  mutation EnsureQrTokensBulk($resourceType: QrResourceType!, $resourceIds: [ID!]!) {
    ensureQrTokensBulk(resourceType: $resourceType, resourceIds: $resourceIds) {
      token
      url
      resourceType
      resourceId
      displayName
      secondaryLabel
    }
  }
`;

export const ENSURE_QR_TOKENS_FOR_ACTIVE_ASSETS_MUTATION = gql`
  mutation EnsureQrTokensForActiveAssets($filter: QrAssetBulkFilterInput) {
    ensureQrTokensForActiveAssets(filter: $filter) {
      token
      url
      resourceType
      resourceId
      displayName
      secondaryLabel
    }
  }
`;

export const ENSURE_QR_TOKENS_FOR_LOCATION_SUBTREE_MUTATION = gql`
  mutation EnsureQrTokensForLocationSubtree($filter: QrLocationSubtreeFilterInput!) {
    ensureQrTokensForLocationSubtree(filter: $filter) {
      token
      url
      resourceType
      resourceId
      displayName
      secondaryLabel
    }
  }
`;

export const PUBLIC_QR_CHAT_MUTATION = gql`
  mutation PublicQrChat($token: String!, $message: String!, $sessionId: String) {
    publicQrChat(token: $token, message: $message, sessionId: $sessionId) {
      answer
      sessionId
      suggestions {
        label
        message
        kind
      }
    }
  }
`;

export const PUBLIC_QR_REPORT_ISSUE_MUTATION = gql`
  mutation PublicQrReportIssue($input: PublicQrReportIssueInput!) {
    publicQrReportIssue(input: $input) {
      issueId
      answer
      suggestions {
        label
        message
        kind
      }
    }
  }
`;
